import { render, staticRenderFns } from "./IbxAppHeader.vue?vue&type=template&id=22237a3c"
import script from "./IbxAppHeader.vue?vue&type=script&lang=ts"
export * from "./IbxAppHeader.vue?vue&type=script&lang=ts"
import style0 from "./IbxAppHeader.vue?vue&type=style&index=0&id=22237a3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports